/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { ApiRequestDto } from '../model/apiRequestDto';
import { AverageData } from '../model/averageData';
import { ControlledMedFillCountResult } from '../model/controlledMedFillCountResult';
import { MedicationSummaryControlledMedOrders } from '../model/medicationSummaryControlledMedOrders';
import { MedicationSummaryCountResult } from '../model/medicationSummaryCountResult';
import { MedicationSummaryResidentContainer } from '../model/medicationSummaryResidentContainer';
import { ResidentCountResult } from '../model/residentCountResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ControlledMedOrdersService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Acetaminophen orders by resident
     * This returns a list of AggregateData        Sample Call      http://URL/api/ControlledMedOrder/ApapDailyDoseDetail
     * @param requestParams Contains request parameters: orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetApapDailyDoseDetail(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public controlledMedOrdersGetApapDailyDoseDetail(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetApapDailyDoseDetail(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetApapDailyDoseDetail(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetApapDailyDoseDetail.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/ControlledMedOrders/ApapDailyDoseDetail`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Acetaminophen order by resident summary
     * This returns a list of AggregateData        Sample Call      http://URL/api/ControlledMedOrder/ApapDailyDoseSummary?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetApapDailyDoseSummary(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetApapDailyDoseSummary(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetApapDailyDoseSummary(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetApapDailyDoseSummary(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetApapDailyDoseSummary.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/ApapDailyDoseSummary`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Top five prescribers total daily dose of acetaminophen
     * This returns a list of AggregateData        Sample Call      http://URL/api/ControlledMedOrder/ApapDailyDoseByPrescriber
     * @param requestParams Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetApapTotalDailyDoseByPrescriber(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetApapTotalDailyDoseByPrescriber(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetApapTotalDailyDoseByPrescriber(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetApapTotalDailyDoseByPrescriber(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetApapTotalDailyDoseByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/ApapDailyDoseByPrescriber`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Top five patients total daily dose of acetaminophen
     * This returns a list of AggregateData        Sample Call      http://URL/api/ControlledMedOrder/ApapDailyDoseByResident
     * @param requestParams Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetApapTotalDailyDoseByResident(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetApapTotalDailyDoseByResident(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetApapTotalDailyDoseByResident(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetApapTotalDailyDoseByResident(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetApapTotalDailyDoseByResident.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/ApapDailyDoseByResident`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns an Average of discontinued controlled medications grouped by facility for the past 6 months
     * Queries controlled medications grouped by facility and calculates an average using all residents who were active at any point during the selected date range.        Sample Call      http://URL/api/ControlledMedOrders/GetAverageDiscontinuedControlledMedsByFacility?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetAverageDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public controlledMedOrdersGetAverageDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public controlledMedOrdersGetAverageDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public controlledMedOrdersGetAverageDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetAverageDiscontinuedControlledMedsByFacility.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/ControlledMedOrders/GetAverageDiscontinuedControlledMedsByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns an Average of new controlled medications grouped by facility for the past 6 months
     * Queries controlled medications grouped by facility and calculates an average using all residents who were active at any point during the selected date range.        Sample Call      http://URL/api/ControlledMedOrders/GetAverageNewControlledMedsByFacility?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetAverageNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public controlledMedOrdersGetAverageNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public controlledMedOrdersGetAverageNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public controlledMedOrdersGetAverageNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetAverageNewControlledMedsByFacility.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/ControlledMedOrders/GetAverageNewControlledMedsByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Controlled Medications Percentage by Resident
     * This returns ResidentCountResult        Sample Call      http://URL/api/ControlledMedOrder/GetAverageNumberOfControlledMedOrdersPerResident?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetAverageNumberOfControlledMedOrdersPerResident(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public controlledMedOrdersGetAverageNumberOfControlledMedOrdersPerResident(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public controlledMedOrdersGetAverageNumberOfControlledMedOrdersPerResident(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public controlledMedOrdersGetAverageNumberOfControlledMedOrdersPerResident(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetAverageNumberOfControlledMedOrdersPerResident.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/ControlledMedOrders/GetAverageNumberOfControlledMedOrdersPerResident`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Controlled medication fills by resident for the last 30 days
     * Returns the number of fills for each resident in the last 30 days for the provided list of facilities.                              Sample Call  http://URL/api/ControlledMedOrders/GetControlledMedFillsByResidentSummary?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedFillsByResidentSummary(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ControlledMedFillCountResult>;
    public controlledMedOrdersGetControlledMedFillsByResidentSummary(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ControlledMedFillCountResult>>;
    public controlledMedOrdersGetControlledMedFillsByResidentSummary(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ControlledMedFillCountResult>>;
    public controlledMedOrdersGetControlledMedFillsByResidentSummary(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedFillsByResidentSummary.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ControlledMedFillCountResult>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedFillsByResidentSummary`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for controlled med fills (Grid Data).
     * Data in this call is not aggregated.        Sample Call      http://URL/api/ControlledMedOrders/GetControlledMedFills?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList, sortFilterDto
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedFillsData(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public controlledMedOrdersGetControlledMedFillsData(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetControlledMedFillsData(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetControlledMedFillsData(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedFillsData.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedFills`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for ControlledMedOrders (Grid Data).
     * This returns ControlledMedOrders.  Data in this call is not aggregated.        Sample Call      http://URL/api/ControlledMedOrder/GetControlledMedOrders?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedOrders(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryControlledMedOrders>;
    public controlledMedOrdersGetControlledMedOrders(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetControlledMedOrders(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetControlledMedOrders(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedOrders.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryControlledMedOrders>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedOrders`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param requestParams 
     * @param ig 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedOrdersWithNoValidPrescription(requestParams: ApiRequestDto, ig?: boolean, id?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryControlledMedOrders>;
    public controlledMedOrdersGetControlledMedOrdersWithNoValidPrescription(requestParams: ApiRequestDto, ig?: boolean, id?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetControlledMedOrdersWithNoValidPrescription(requestParams: ApiRequestDto, ig?: boolean, id?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetControlledMedOrdersWithNoValidPrescription(requestParams: ApiRequestDto, ig?: boolean, id?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedOrdersWithNoValidPrescription.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryControlledMedOrders>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedOrdersWithNoValidPrescription`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of orders for Controlled Medication
     * Percentage of the number of residents on controlled orders                   Sample Call     http://URL/api/ControlledMedOrder/GetControlledMedPercentage?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedPercentage(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryCountResult>;
    public controlledMedOrdersGetControlledMedPercentage(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryCountResult>>;
    public controlledMedOrdersGetControlledMedPercentage(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryCountResult>>;
    public controlledMedOrdersGetControlledMedPercentage(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedPercentage.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryCountResult>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedPercentage`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns controlled medications grouped by facility
     * Queries controlled medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetControlledMedsByFacility?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedsByFacility.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedsByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns controlled medication grouped by prescriber.
     * Queries controlled medications and returns groupings by Prescriber and then facility.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetControlledMedsByPrescriber?filter&#x3D;All&amp;amp;ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetControlledMedsByPrescriber(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetControlledMedsByPrescriber(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetControlledMedsByPrescriber(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetControlledMedsByPrescriber(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetControlledMedsByPrescriber.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetControlledMedsByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Discontinued controlled medications grouped by facility for the past 6 months
     * Queries Discontinued controlled medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/ControlledMedOrders/GetDiscontinuedControlledMedsByFacility?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetDiscontinuedControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetDiscontinuedControlledMedsByFacility.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetDiscontinuedControlledMedsByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for GetExpiredExpiringSoon (Grid Data).
     * This returns GetExpiredExpiringSoon.  Data in this call is not aggregated.        Sample Call      http://URL/api/ControlledMedOrder/GetExpiredExpiringSoon?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetExpiredExpiringSoon(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryControlledMedOrders>;
    public controlledMedOrdersGetExpiredExpiringSoon(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetExpiredExpiringSoon(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetExpiredExpiringSoon(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetExpiredExpiringSoon.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryControlledMedOrders>(`${this.basePath}/api/ControlledMedOrders/GetExpiredExpiringSoon`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Count of controlled medication that is expired or expiring soon
     * Sample Call  http://URL/api/ControlledMedOrder/GetExpiredExpiringSoonCount?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetExpiredExpiringSoonCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public controlledMedOrdersGetExpiredExpiringSoonCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public controlledMedOrdersGetExpiredExpiringSoonCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public controlledMedOrdersGetExpiredExpiringSoonCount(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetExpiredExpiringSoonCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/ControlledMedOrders/GetExpiredExpiringSoonCount`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the top five (5) residents with the least controlled med order fills in the last 30 days.
     * Data in this call is aggregated.  Note that residents with zero fills are not considered in this data set.        Sample Call      http://URL/api/ControlledMedOrders/LeastFillsByResidentLast30Days?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetLeastFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetLeastFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetLeastFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetLeastFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetLeastFillsByResidentLast30Days.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/LeastFillsByResidentLast30Days`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for GetLessThanFifteenPercentQtyRemaining (Grid Data).
     * This returns GetLessThanFifteenPercentQtyRemaining.  Data in this call is not aggregated.        Sample Call      http://URL/api/ControlledMedOrder/GetLessThanFifteenPercentQtyRemaining?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemaining(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryControlledMedOrders>;
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemaining(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemaining(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemaining(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetLessThanFifteenPercentQtyRemaining.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryControlledMedOrders>(`${this.basePath}/api/ControlledMedOrders/GetLessThanFifteenPercentQtyRemaining`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Count of controlled medications that have a qty of less than 15% remaining
     * Sample Call  http://URL/api/ControlledMedOrder/GetLessThanFifteenPercentQtyRemainingCount?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemainingCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemainingCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemainingCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public controlledMedOrdersGetLessThanFifteenPercentQtyRemainingCount(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetLessThanFifteenPercentQtyRemainingCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/ControlledMedOrders/GetLessThanFifteenPercentQtyRemainingCount`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Top five prescribers by total prescribed morphine equivalent medications (opioids).
     * This returns a list of AggregateData                    Sample Call      http://URL/api/ControlledMedOrder/MorphineEquivalentByPrescriber?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMorphineEquivalentByPrescriber(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetMorphineEquivalentByPrescriber(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetMorphineEquivalentByPrescriber(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetMorphineEquivalentByPrescriber(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMorphineEquivalentByPrescriber.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetMorphineEquivalentByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/MorphineEquivalentByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Top five residents by total daily dose of morphine equivalent medications (opioids).
     * This returns a list of AggregateData                    Sample Call      http://URL/api/ControlledMedOrder/MorphineEquivalentByResident?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMorphineEquivalentByResident(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetMorphineEquivalentByResident(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetMorphineEquivalentByResident(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetMorphineEquivalentByResident(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMorphineEquivalentByResident.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetMorphineEquivalentByResident.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/MorphineEquivalentByResident`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Morphine equivalent orders by resident (opioids)
     * This returns a list of MedicationSummary&amp;lt;ResidentContainer%gt;                    Sample Call      http://URL/api/ControlledMedOrder/MorphineEquivalentDetail?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList, sortFilterDto
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMorphineEquivalentDetail(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public controlledMedOrdersGetMorphineEquivalentDetail(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetMorphineEquivalentDetail(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetMorphineEquivalentDetail(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMorphineEquivalentDetail.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetMorphineEquivalentDetail.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/ControlledMedOrders/MorphineEquivalentDetail`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Morphine equivalent orders by resident - summary
     * This returns ResidentCountResult        Sample Call      http://URL/api/ControlledMedOrder/MorphineEquivalentSummary
     * @param requestParams Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMorphineEquivalentSummary(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetMorphineEquivalentSummary(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetMorphineEquivalentSummary(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetMorphineEquivalentSummary(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMorphineEquivalentSummary.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/MorphineEquivalentSummary`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the top five (5) residents with the most controlled med order fills in the last 30 days.
     * Data in this call is aggregated.        Sample Call      http://URL/api/ControlledMedOrders/MostFillsByResidentLast30Days?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMostFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetMostFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetMostFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetMostFillsByResidentLast30Days(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMostFillsByResidentLast30Days.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/MostFillsByResidentLast30Days`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Multiple Controlled Meds In Same Drug Category By Drug Group  (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of controlled meds that facility has that belongs to that drug group.          Sample Call      http://URL/api/ControlledMeds/GetMultipleControlledMedsInSameDrugCategoryByDrugGroup?filter&#x3D;All&amp;amp;ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param filter One of All|PRN|Routine
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByDrugGroup(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByDrugGroup(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByDrugGroup(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByDrugGroup(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByDrugGroup.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByDrugGroup.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetMultipleControlledMedsInSameDrugCategoryByDrugGroup`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Controlled Medication grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/MedicationSummary/GetMultipleControlledMedsInSameDrugCatetoryByPrescriber?filter&#x3D;All&amp;amp;ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param filter One of All|PRN|Routine
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByPrescriber(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByPrescriber(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByPrescriber(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByPrescriber(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByPrescriber.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryByPrescriber.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetMultipleControlledMedsInSameDrugCategoryByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Controlled Meds (Grid Data).
     * This returns ControlledMeds.  Data in this call is not aggregated.        Sample Call      http://URL/api/ControlledMeds/GetMultipleControlledMedsInSameDrugCatetoryData?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList, sortFilterDto
     * @param filter One of All|PRN|Routine
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryData(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryData(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryData(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryData(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryData.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetMultipleControlledMedsInSameDrugCategoryData.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/ControlledMedOrders/GetMultipleControlledMedsInSameDrugCategoryData`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Grid data of new and discontinued controlled meds by resident
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/ControlledMedOrders/GetNewAndDiscontinuedByResident?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetNewAndDiscontinuedControlledMedsByResident(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryControlledMedOrders>;
    public controlledMedOrdersGetNewAndDiscontinuedControlledMedsByResident(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetNewAndDiscontinuedControlledMedsByResident(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetNewAndDiscontinuedControlledMedsByResident(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetNewAndDiscontinuedControlledMedsByResident.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryControlledMedOrders>(`${this.basePath}/api/ControlledMedOrders/GetNewAndDiscontinuedByResident`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Number of new and Discontinued orders over the last 6 months
     * Data in this call is aggregated by each month.                    Sample Call      http://URL/api/OrderSummary/GetAverageRoutineOrdersByMonth?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetNewAndDiscontinuedOrdersPastSixMonths(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetNewAndDiscontinuedOrdersPastSixMonths(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetNewAndDiscontinuedOrdersPastSixMonths(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetNewAndDiscontinuedOrdersPastSixMonths(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetNewAndDiscontinuedOrdersPastSixMonths.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetNewAndDiscontinuedOrdersPastSixMonths`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns New controlled medications grouped by facility for the past 6 months
     * Queries controlled medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/ControlledMedOrders/GetNewControlledMedsByFacility?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetNewControlledMedsByFacility(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetNewControlledMedsByFacility.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetNewControlledMedsByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Count of controlled medication orders with no valid prescription
     * Sample Call  http://URL/api/ControlledMedOrder/GetNoValidPrescriptionCount
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetNoValidPrescriptionCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public controlledMedOrdersGetNoValidPrescriptionCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public controlledMedOrdersGetNoValidPrescriptionCount(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public controlledMedOrdersGetNoValidPrescriptionCount(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetNoValidPrescriptionCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/ControlledMedOrders/GetNoValidPrescriptionCount`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Top five prescribers by total prescribed Opioids and Benzodiazepines medications (opioids).
     * This returns a list of AggregateData                    Sample Call      http://URL/api/ControlledMedOrder/OpioidAndBenzoByPrescriber?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetOpioidAndBenzoByPrescriber(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetOpioidAndBenzoByPrescriber(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetOpioidAndBenzoByPrescriber(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetOpioidAndBenzoByPrescriber(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoByPrescriber.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/OpioidAndBenzoByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Top five residents by total daily dose of Opioids and Benzodiazepines medications (opioids).
     * This returns a list of AggregateData                    Sample Call      http://URL/api/ControlledMedOrder/OpioidAndBenzoByResident?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetOpioidAndBenzoByResident(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetOpioidAndBenzoByResident(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetOpioidAndBenzoByResident(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetOpioidAndBenzoByResident(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoByResident.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoByResident.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/OpioidAndBenzoByResident`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Opioids and Benzodiazepines orders by resident (opioids)
     * This returns a list of MedicationSummary&amp;lt;ResidentContainer%gt;                    Sample Call      http://URL/api/ControlledMedOrder/OpioidAndBenzoDetail?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList, sortFilterDto
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetOpioidAndBenzoDetail(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public controlledMedOrdersGetOpioidAndBenzoDetail(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetOpioidAndBenzoDetail(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public controlledMedOrdersGetOpioidAndBenzoDetail(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoDetail.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoDetail.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/ControlledMedOrders/OpioidAndBenzoDetail`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Opioids and Benzodiazepines orders by resident - summary
     * This returns ResidentCountResult        Sample Call      http://URL/api/ControlledMedOrder/OpioidAndBenzoSummary?filter&#x3D;All
     * @param requestParams Contains request parameters: orgList
     * @param filter Order type to filter by, should be \&quot;All\&quot;, \&quot;Routine\&quot;, or \&quot;PRN\&quot;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetOpioidAndBenzoSummary(requestParams: ApiRequestDto, filter: string, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public controlledMedOrdersGetOpioidAndBenzoSummary(requestParams: ApiRequestDto, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public controlledMedOrdersGetOpioidAndBenzoSummary(requestParams: ApiRequestDto, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public controlledMedOrdersGetOpioidAndBenzoSummary(requestParams: ApiRequestDto, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoSummary.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetOpioidAndBenzoSummary.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/ControlledMedOrders/OpioidAndBenzoSummary`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Controlled Medication by Drug Group
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of controlled medications that facility has that belongs to that drug group.          Sample Call      http://URL/api/ControlledMedOrder/GetResidentsOnControlledMedOrdersByDrugGroup?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetResidentsOnControlledMedOrdersByDrugGroup(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetResidentsOnControlledMedOrdersByDrugGroup(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetResidentsOnControlledMedOrdersByDrugGroup(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetResidentsOnControlledMedOrdersByDrugGroup(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetResidentsOnControlledMedOrdersByDrugGroup.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/GetResidentsOnControlledMedOrdersByDrugGroup`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Grid data of Controlled Meds Per Resident
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/MedicationSummary/GetResidentsOnControlledMeds?ig&#x3D;false
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetResidentsOnControlledMeds(requestParams: ApiRequestDto, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryControlledMedOrders>;
    public controlledMedOrdersGetResidentsOnControlledMeds(requestParams: ApiRequestDto, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetResidentsOnControlledMeds(requestParams: ApiRequestDto, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryControlledMedOrders>>;
    public controlledMedOrdersGetResidentsOnControlledMeds(requestParams: ApiRequestDto, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetResidentsOnControlledMeds.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryControlledMedOrders>(`${this.basePath}/api/ControlledMedOrders/GetResidentsOnControlledMeds`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residents that have more than one Controlled Med by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/MedicationSummary/ResidentsWithMultipleControlledMedsByDrugOrder?ig&#x3D;false
     * @param requestParams Contains request parameters: orgList
     * @param filter One of All|PRN|Routine
     * @param ig Flag to control whether to return orders for Gabapentin and its equivalents
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public controlledMedOrdersGetResidentsWithMultipleControlledMedsByDrugOrder(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public controlledMedOrdersGetResidentsWithMultipleControlledMedsByDrugOrder(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public controlledMedOrdersGetResidentsWithMultipleControlledMedsByDrugOrder(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public controlledMedOrdersGetResidentsWithMultipleControlledMedsByDrugOrder(requestParams: ApiRequestDto, filter: string, ig?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling controlledMedOrdersGetResidentsWithMultipleControlledMedsByDrugOrder.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling controlledMedOrdersGetResidentsWithMultipleControlledMedsByDrugOrder.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (ig !== undefined && ig !== null) {
            queryParameters = queryParameters.set('ig', <any>ig);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/ControlledMedOrders/ResidentsWithMultipleControlledMedsByDrugOrder`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
